export default __webpack_public_path__ + "static/media/rating-4.ef8c0db3.webp";